module.exports = __webpack_public_path__ + "static/img/编组.98299bd5.svg";